import {ApiStatusCodeVo} from '../../common/shared/api/nicolas/vo/enums/ApiStatusCodeVo.enum';
import {RouletteEntryType, RouletteStatus} from '../../graphql/generated/types';
import {RouletteLogType} from './type';

export const ROULETTE_RESULT_TEXT_MAP: {[key in RouletteStatus]: string} = {
  [RouletteStatus.First]: '',
  [RouletteStatus.Fail]: '캐시지급에\n실패하였습니다.',
  [RouletteStatus.TicketFail]: '대여권지급에\n실패하였습니다.',
  [RouletteStatus.Duplicate]: '중복된 요청이 있습니다.\n다시 시도해주세요.',
  [RouletteStatus.BudgetCrunch]: '지금은 이벤트에\n참여할 수 없습니다.',
  [RouletteStatus.Already]: '이미 뽑기를\n진행하셨습니다.',
  [RouletteStatus.Disable]: '지금은 이벤트에\n참여할 수 없습니다.',
  [RouletteStatus.Expire]: '뽑기 기간이\n종료되었습니다.',
  [RouletteStatus.Noauth]: '지금은 이벤트에\n참여할 수 없습니다.',
  [RouletteStatus.Error]: '지금은 이벤트에\n참여할 수 없습니다.',
  [RouletteStatus.WaitRedeemResult]: '',
  [RouletteStatus.Draw]: '',
  [RouletteStatus.Success]: '축하합니다!',
  [RouletteStatus.UnknownApiStatus]: '뽑기 기간이\n종료되었습니다.',
  [RouletteStatus.Unknown]: '지금은 이벤트에\n참여할 수 없습니다.',
};

export const ROULETTE_API_STATUS_RESULT_TEXT_MAP: {
  [key in ApiStatusCodeVo]?: string;
} = {
  [ApiStatusCodeVo.RedeemUseFail]:
    '일시적인 오류가 발생\n했습니다. 잠시 후 다시 시도해 주세요.',
  [ApiStatusCodeVo.RedeemAlreadyUsed]:
    '이미 사용된 응모 번호\n입니다. 다른 응모 번호를\n입력해 주세요.',
  [ApiStatusCodeVo.RedeemAlreadyReceived]:
    '이미 사용된 응모 번호\n입니다. 다른 응모 번호를\n입력해 주세요.',
  [ApiStatusCodeVo.RedeemExpiredCoupon]: '사용 기간이 만료된\n응모 번호입니다.',
  [ApiStatusCodeVo.RedeemAlreadyUsedCodeGroup]:
    '이 이벤트는 중복 참여가\n불가능합니다.',
  [ApiStatusCodeVo.RedeemTooShortRequest]: '같은 코드의 요청이\n처리 중입니다.',
  [ApiStatusCodeVo.RedeemOnlyNewlyJoinedUser]:
    '이 이벤트는 신규 회원만\n참여가 가능합니다.',
  [ApiStatusCodeVo.RedeemOnlyReturnUser]:
    '이 이벤트는 복귀 회원만\n참여가 가능합니다.',
  [ApiStatusCodeVo.RedeemOnlyNewlyJoinedUserAfter]:
    '유효하지 않은 응모 번호\n입니다. 다시 한번 확인해주세요.',
  [ApiStatusCodeVo.RedeemOnlyNewlyJoinedUserBefore]:
    '유효하지 않은 응모 번호\n입니다. 다시 한번 확인해주세요.',
  [ApiStatusCodeVo.RedeemProductNotOnSale]:
    '유효하지 않은 응모 번호\n입니다. 다시 한번 확인해주세요.',
  [ApiStatusCodeVo.RedeemInvalidForm]:
    '유효하지 않은 응모 번호\n입니다. 다시 한번 확인해주세요.',
  [ApiStatusCodeVo.RedeemInvalidCoupon]:
    '유효하지 않은 응모 번호\n입니다. 다시 한번 확인해주세요.',
  [ApiStatusCodeVo.GotchaInvalidTarget]: '캐시 뽑기 대상자가\n아닙니다.',
};

const ROULETTE_TYPE_LOG_MAP = {
  [RouletteEntryType.Redeem]: RouletteLogType.Redeem,
  [RouletteEntryType.Direct]: RouletteLogType.Direct,
  [RouletteEntryType.None]: RouletteLogType.Cash,
  [RouletteEntryType.CashSponsorAd]: RouletteLogType.Cash,
  [RouletteEntryType.DirectV2]: RouletteLogType.Direct,
  [RouletteEntryType.RedeemV2]: RouletteLogType.Redeem,
};
export function getRouletteLogType(
  entryType: RouletteEntryType = RouletteEntryType.None
) {
  return ROULETTE_TYPE_LOG_MAP[entryType];
}

export const DEFAULT_ROULETTE_BG_COLOR = '#692FE5';

export const ROULETTE_INPUT_BOX_CLASSNAME = 'roulette-input-box';
